<template>
  <v-card>
    <v-toolbar color="teal" dark flat dense cad>
      <v-toolbar-title class="body-2">Ingresar Usuario</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <v-text-field
              label="Email"
              name="email"
              v-model="email"
            ></v-text-field>
            <v-text-field
              label="Nombre"
              name="nombre"
              v-model="nombre"
            ></v-text-field>
            <v-text-field
              label="Apellido 1"
              name="apellido1"
              v-model="apellido1"
            ></v-text-field>
            <v-text-field
              label="Apellido 2"
              name="apellido2"
              v-model="apellido2"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-subheader>Seleccione Rol</v-subheader>
          </v-flex>
          <v-flex xs6>
            <v-select
              :items="roles"
              v-model="rol"
              label=""
              item-text="roles"
              item-value="roles"
              class="input-group--focused"
            ></v-select>
          </v-flex>
          <div>
            <v-switch
              v-model="proveedor"
              :label="`Es proveedor: ${proveedor.toString()}`"
            ></v-switch>
          </div>
          <v-flex lg12 sm12>
            <v-checkbox v-model="checkbox">
              <template v-slot:label>
                <div>
                  Estoy de acuerdo con los terminos y condiciones de la
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="https://terminosycondiciones.cl"
                        @click.stop
                        v-on="on"
                      >
                        Agencia
                      </a>
                    </template>
                    Opens in new window
                  </v-tooltip>
                  en su totalidad
                </div>
              </template>
            </v-checkbox>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn color="primary">Agregar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import VWidget from "@/components/VWidget";
export default {
  data: () => ({
    email: null,
    nombre: null,
    apellido1: null,
    apellido2: null,
    roles: [
      "Agencia Aprobador",
      "Agencia Administrador",
      "Agencia Validador",
      "Supervisor",
    ],
    rol: null,
    proveedor: false,
    checkbox: true,
    valid: true,
  }),
};
</script>
